import { md5, rsa } from '@/util/encrypt'
import { validateNumber } from '@/util/validation'
import helper from '@/util/signinHelper'

import { apiSecurityPassed, apiGetUserLocation } from '@/resource'

import v1 from '@/assets/images/verification/v1.jpg'
import v2 from '@/assets/images/verification/v2.jpg'
import v3 from '@/assets/images/verification/v3.jpg'
import v4 from '@/assets/images/verification/v4.jpg'
import v5 from '@/assets/images/verification/v5.jpg'
import v6 from '@/assets/images/verification/v6.jpg'

import countryCodeEn from '@/assets/data/countrycode_en.json'
import countryCodeCn from '@/assets/data/countrycode_cn.json'
import { sensorsTrack } from '@/util/sensorsdata'
import { SENSORS_TRACK } from '@/util/sensorsdata/constant'

export default {
  data() {
    return {
      needVerification: false,
      countryCodeEnJson: countryCodeEn,
      countryCodeCnJson: countryCodeCn,
      codes: [],
      msg: '',
      loginOptions: [
        { label: this.$t('common.field.emailAdd'), value: 'email' },
        { label: this.$t('common.field.phone'), value: 'phone' },
      ],
      imgs: [v1, v2, v3, v4, v5, v6],
      emailLoginForm: {
        userName_login: '',
        password_login: '',
      },
      phoneLoginForm: {
        countrycode_login: '',
        phone_login: '',
        password_login: '',
      },
      emailLoginFormRules: {
        userName_login: [
          {
            required: true,
            message: this.$t('loginClient.formValidation.emailReq'),
            trigger: 'blur',
          },
        ],
        password_login: [
          {
            required: true,
            message: this.$t('common.formValidation.pwReq'),
            trigger: 'blur',
          },
        ],
      },
      phoneLoginFormRules: {
        countrycode_login: [
          {
            required: true,
            trigger: 'blur',
            validator: validateNumber,
          },
        ],
        phone_login: [
          {
            required: true,
            trigger: 'blur',
            validator: validateNumber,
          },
        ],
        password_login: [
          {
            required: true,
            message: this.$t('common.formValidation.pwReq'),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    currentTab(value) {
      if (value === 'phone') {
        this.getCode()
        this.getLoc()
      }
    },
  },
  computed: {
    failedSecondTime() {
      return this.$store.state.common.failedSecondTime
    },
    lang() {
      return this.$store.state.common.lang
    },
  },
  methods: {
    invokeVerification() {
      this.needVerification = true
    },
    onSuccess() {
      apiSecurityPassed({
        data: rsa('feliscatus:' + Number(new Date())),
      })
        .then(resp => {
          this.needVerification = false
          this.$store.commit('common/setFailedSecondTime', false)
        })
        .catch(err => {
          console.log(err)
        })
      this.msg = ''
    },
    onFail() {
      this.msg = this.$t('loginClient.failedMasseage')
    },
    onRefresh() {
      this.msg = ''
    },
    //检测到非人为操作滑动时触发的回调函数
    onAgain() {
      this.msg = this.$t('loginClient.failedMasseage')
      this.$refs.slideblock.reset()
    },
    emailLoginSubmit() {
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.LOGIN_PAGE_CLICK, { button_name: SENSORS_TRACK.BUTTON_NAME.EMAIL_LOGIN })
      this.$refs['emailLoginForm'].validate(valid => {
        if (valid) this.checkIfAllowed()
      })
    },
    checkIfAllowed() {
      if (!this.failedSecondTime) {
        this.login()
      } else {
        this.invokeVerification()
      }
    },
    login() {
      const userName_login = rsa(this.emailLoginForm.userName_login)
      const password_login = md5(this.emailLoginForm.password_login)
      helper.signIn(userName_login, password_login)
    },
    handleSelect(item) {
      this.phoneLoginForm.countrycode_login = item.code
    },
    phoneLoginSubmit() {
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.LOGIN_PAGE_CLICK, { button_name: SENSORS_TRACK.BUTTON_NAME.MOBILE_LOGIN })
      this.$refs['phoneLoginForm'].validate(valid => {
        if (valid) {
          if (!this.failedSecondTime) {
            this.phoneLogin()
          } else {
            this.invokeVerification()
          }
        }
      })
    },
    phoneLogin() {
      const countrycode_login = this.phoneLoginForm.countrycode_login
      const phone_login = rsa(this.phoneLoginForm.phone_login)
      const password_login = md5(this.phoneLoginForm.password_login)
      helper.signInMobile(countrycode_login, phone_login, password_login)
    },
    getLoc() {
      let country = ''
      let countryCode
      apiGetUserLocation().then(resp => {
        let res = resp.data.split(/\n/g).filter(line => line.trim())
        for (const element of res) {
          if (element.slice(0, 3) === 'loc') {
            country = element.slice(4)
            let filteredCountry = this.countryCodeEnJson.filter(function (p) {
              return p.iso_country_code === country.toUpperCase()
            })
            countryCode = filteredCountry[0].code
          }
        }
        this.userCountry = country
        this.phoneLoginForm.countrycode_login = countryCode
      })
    },
    formatValues(dataValue) {
      return dataValue.map(e => {
        const [codeLabel, codeValue] = e.value.split('+')
        return {
          ...e,
          codeValue: `+${codeValue}`,
          codeLabel,
        }
      })
    },
    getCode() {
      if (this.lang === 'zh_CN') {
        this.codes = this.formatValues(this.countryCodeCnJson)
      } else {
        this.codes = this.formatValues(this.countryCodeEnJson)
      }
    },
  },
}
